module.exports = __webpack_public_path__ + "media/pt_pt_s1_Alfonso.68ac337d.oga";